/* Copy-to-clipboard + mailto helper for page-submit.hbs. There's no backend
   to post a form to, so the page just shows a plain-text email template and
   this either copies it verbatim or opens it as a pre-filled mailto: link.
   The template text lives once, in the <pre>, and both actions read from it
   rather than duplicating the copy here. */
(function () {
    const wrapper = document.querySelector('[data-mail-to]');
    if (!wrapper) return;

    const templateEl = wrapper.querySelector('[data-void-tip-template]');
    const copyButton = wrapper.querySelector('[data-void-tip-copy]');
    const mailtoLink = wrapper.querySelector('[data-void-tip-mailto]');
    const copiedEl = wrapper.querySelector('[data-void-tip-copied]');
    const mailTo = wrapper.getAttribute('data-mail-to');

    function templateParts() {
        const raw = templateEl.textContent;
        const lines = raw.split('\n');
        const subject = (lines[0] || '').replace(/^Subject:\s*/, '');
        const body = lines.slice(2).join('\n');
        return {raw, subject, body};
    }

    if (mailtoLink) {
        const {subject, body} = templateParts();
        mailtoLink.href = 'mailto:' + mailTo +
            '?subject=' + encodeURIComponent(subject) +
            '&body=' + encodeURIComponent(body);
    }

    if (copyButton) {
        copyButton.addEventListener('click', function () {
            const {raw} = templateParts();

            const done = function () {
                copiedEl.hidden = false;
                clearTimeout(copyButton._voidTipTimer);
                copyButton._voidTipTimer = setTimeout(function () {
                    copiedEl.hidden = true;
                }, 4000);
            };

            if (navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(raw).then(done, function () {
                    selectTemplate();
                });
            } else {
                selectTemplate();
            }
        });
    }

    function selectTemplate() {
        const range = document.createRange();
        range.selectNodeContents(templateEl);
        const selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);
    }
})();
